import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  tableRow: {
    display: 'flex',
    flexDirection: 'row'
  }
});

export const TableRow = (props: any) => {
  return (
    <View style={styles.tableRow}>
      {props.children}
    </View>
  )
};

export default TableRow;
